import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ArrowLeftIcon, ArrowRightIcon } from '@ninja/icons/web';
import { getTzStartOfYear, addYears, setTimeToDay, formatDate } from '@ninja/utilities';
import styles from './DatePicker4.js';
import { checkIsValidRangeForMonthHeaderView } from './utils6.js';
import { useCalendarViewContext } from './components10.js';

const MonthsViewHeader = () => {
    const { updateViewState, viewState: { tzDate, currentCalendar, intervalEndDate, intervalStartDate }, fromDate, toDate, enableTimeSelection, isIntervalPicker, maxSelectionRangeDays, } = useCalendarViewContext();
    const currentYearDate = getTzStartOfYear(tzDate);
    const { allowNextYear, allowPreviousYear } = checkIsValidRangeForMonthHeaderView({
        isIntervalPicker,
        maxSelectionRangeDays,
        intervalStartDate,
        intervalEndDate,
        currentYearDate,
        toDate,
        fromDate,
    });
    return (jsxs(Fragment, { children: [jsx("div", { className: styles.navigationIconContainer(!allowPreviousYear), onClick: () => {
                    if (allowPreviousYear) {
                        const newDate = addYears(currentYearDate, -1);
                        updateViewState({ tzDate: enableTimeSelection ? setTimeToDay(tzDate, newDate) : newDate });
                    }
                }, children: jsx(ArrowLeftIcon, { className: styles.navigationIcon(!allowPreviousYear) }) }), jsx("div", { className: styles.dayViewLink.container, onClick: () => {
                    updateViewState({ viewMode: 'years' });
                }, children: formatDate(currentYearDate, {
                    dateFormat: 'yyyy',
                    calendar: currentCalendar,
                }) }), jsx("div", { className: styles.navigationIconContainer(!allowNextYear), onClick: () => {
                    if (allowNextYear) {
                        const newDate = addYears(currentYearDate, +1);
                        updateViewState({ tzDate: enableTimeSelection ? setTimeToDay(tzDate, newDate) : newDate });
                    }
                }, children: jsx(ArrowRightIcon, { className: styles.navigationIcon(!allowNextYear) }) })] }));
};

export { MonthsViewHeader };
